import React from 'react'
import ModalComponent from './ModalComponent'

import { useState } from "react"
import { v4 as uuidv4 } from 'uuid';

export default function CreatePoll(props) {


    const [title, setTitle] = useState("")

    const [inputFields, setInputFields] = useState([{
        option: '',
        vote: 0
    }]);

    const addInputField = () => {
        setInputFields([...inputFields, {
            option: '',
            vote: 0,

        }])

    }
    const removeInputFields = (index) => {
        const rows = [...inputFields];
        rows.splice(index, 1);
        setInputFields(rows);
    }
    const handleChange = (index, evnt) => {

        const { name, value } = evnt.target;
        const list = [...inputFields];
        list[index][name] = value;
        list[index]["id"] = uuidv4();
        list[index]["vote"] = 0;

        setInputFields(list);

    }

    const submitClick = () => {
        let data = {
            id: uuidv4(),
            title: title,
            options: inputFields,
            type: "POLL"
        }

        props.pollData(data)
        props.closeModal()
    }



    return (
        <div>
            {props.showCreatePollModal ?
                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header pb-0">
                                <button type="button" class="btn-close" aria-label="Close" onClick={() => props.closeModal()}></button>
                            </div>
                            <div class="modal-body pt-0">

                                <h5 className=''>Poll title</h5>
                                <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="" maxLength={65} required onChange={(e) => setTitle(e.target.value)} />

                                <div className="col-sm-12 pt-3">
                                    <h5 className='mb-0'>Poll Options</h5>

                                    {
                                        inputFields.map((data, index) => {
                                            const { option } = data;
                                            return (
                                                <div className="row pb-0" key={index}>
                                                    <div className="col-md-10 ps-0 pt-0">
                                                        <div className="form-group">
                                                            <input type="text" onChange={(evnt) => handleChange(index, evnt)} value={option} name="option" className="form-control" placeholder="option" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-2 ps-0 pe-0">
                                                        {(inputFields.length !== 1) ? <button className="btn btn-danger" onClick={removeInputFields}>x</button> : ''}
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                    <div className="row">
                                        <div className="col-sm-12 ps-0">
                                            <button className="btn btn-outline-success " onClick={addInputField}>Add New</button>
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex justify-content-end mt-2'>
                                    <button type="button" class="btn btn-primary" onClick={() => submitClick()}>Submit</button>

                                </div>


                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
